import { render, staticRenderFns } from "./EfsCapCertificateForm.vue?vue&type=template&id=b860442a&"
import script from "./EfsCapCertificateForm.vue?vue&type=script&lang=js&"
export * from "./EfsCapCertificateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports